<template>
  <div>
    <nav-breadcrumb :menu="[{label: '缴纳保证金'}]"/>

    <el-row>
      <el-col>
        <panel>
          <el-form :model="depositForm" :rules="depositFormFormRules" ref="depositForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="24">
                <el-form-item label="渠道商：" prop="t__dealerId" :rules="{required: true, message: '渠道商不能为空'}" style="width: 27%">
                  <el-select placeholder="请选择渠道商" v-model.trim="depositForm.t__dealerId" filterable>
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in dealerOptions" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="缴纳金额：" prop="t__txAmount"  :rules="{required: true, message: '缴纳金额不能为空'}" style="width: 27%">
                  <el-input v-model="depositForm.t__txAmount" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="缴纳日期：" prop="t__applicationDate"  :rules="{required: true, message: '缴纳日期不能为空'}" style="width: 27%">
                  <el-date-picker
                    v-model="depositForm.t__applicationDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="流水号："style="width: 27%">
                  <el-input v-model="depositForm.t__reference" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注："style="width: 27%">
                  <el-input v-model="depositForm.t__remarks" type="textarea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </panel>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('depositForm')">保存</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </div>
    
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
    export default {
        name: "DepositApplicationDA",
      data(){
        return {
          depositForm:{
          },
          dealerOptions : [],
          depositFormFormRules: {},
        }
      },
      mounted() {

        this.getDealerList()
      },
      methods:{
        /*getData:function(){
          xhr.getDealerUser({
              'du.userId': this.userId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.dealerUserForm = Object.assign({}, res.data.data, {
                    r__roleName: res.data.data.detail[0].r__role
                  })
                }
              }catch (e) {

              }
            })
        },*/
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.dealerOptions = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },
        onSubmit: function (formName) {
          let depositForm = this.depositForm
          this.$refs[formName].validate(valid=> {
            if (valid) {
              depositForm.t__checked = true
              depositForm.t__applicationTypeCode = 'DA'
              depositForm['t.applicationDate.dateformat'] = 'yyyy-MM-dd'
              xhr.updateDepositApplication(depositForm, res=> {
                try {
                  if (res.data.status == 'success') {
                    this.$router.push({
                      name: 'DepositApplicationForApprovalListView'
                    })
                  }
                } catch (e) {
                }
              })
            }
          })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/DepositApplicationDA.vue